import { Button, Card, CardActions, Stack, Typography } from '@mui/material'
import React, { useState } from 'react'

import Icon from 'components/Icon'

import { DidYouKnow } from './DidYouKnow'
import { HowReliabilityIsMeasured } from './HowReliabilityIsMeasured'
import { WhatAreGoldenSignals } from './WhatAreGoldenSignals'
import { WhatIsAReliabilityTest } from './WhatIsAReliabilityTest'
import { WhatIsAService } from './WhatIsAService'

export const ReliabilityManagement101Tutorial: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<number>(0)
  const maxPages = 5

  const goToNextPage = () => {
    setCurrentPage(currentPage + 1)
  }

  const goToPreviousPage = () => {
    setCurrentPage(currentPage - 1)
  }

  return (
    <Card data-test-reliability-management-tutorial>
      {currentPage === 0 && <WhatAreGoldenSignals />}
      {currentPage === 1 && <WhatIsAReliabilityTest />}
      {currentPage === 2 && <WhatIsAService />}
      {currentPage === 3 && <HowReliabilityIsMeasured />}
      {currentPage === 4 && <DidYouKnow />}
      <CardActions>
        <Stack
          alignItems="center"
          direction="row"
          flex={1}
          justifyContent="space-between"
        >
          <Button
            data-testid="getting-started-previous-tutorial"
            disabled={currentPage === 0}
            size="small"
            startIcon={<Icon icon="arrowLeft" />}
            onClick={goToPreviousPage}
          >
            Back
          </Button>
          <Typography variant="body2">
            {currentPage + 1}/{maxPages}
          </Typography>
          <Button
            data-testid="getting-started-next-tutorial"
            disabled={currentPage === maxPages - 1}
            endIcon={<Icon icon="arrowRight" />}
            size="small"
            onClick={goToNextPage}
          >
            Next
          </Button>
        </Stack>
      </CardActions>
    </Card>
  )
}
